import {
  getDate,
  getDay,
  setDate,
  setHours,
  setMinutes,
  setSeconds,
  startOfMonth
} from 'date-fns';
import { NUMBER_OF_DAYS_IN_WEEK } from '../../constants';
import type { ScheduleSolversTimeConfigType } from '../../types';
import { numDayOfWeekInMonth } from '../../utils/num-day-of-week-in-month';

export const nthDayInMonthTime = ({
  startDate,
  endDate,
  userDate
}: ScheduleSolversTimeConfigType) => {
  const viewDuration = endDate.getTime() - startDate.getTime();

  const startHour = startDate.getHours();
  const startMinutes = startDate.getMinutes();
  const startSeconds = startDate.getMinutes();
  const startOfMonthDate = startOfMonth(userDate);

  const firstWeekDates = [];
  for (let i = 1; i <= NUMBER_OF_DAYS_IN_WEEK; i++) {
    const date = setDate(startOfMonthDate, i);
    const weekDay = getDay(date);
    firstWeekDates[weekDay] = i;
  }

  const startDateWeekday = getDay(startDate);
  const startDateDay = getDate(startDate);
  const nth = numDayOfWeekInMonth(startDateDay);

  const dayInThisMonth =
    firstWeekDates[startDateWeekday] + NUMBER_OF_DAYS_IN_WEEK * (nth - 1);

  const startDateInThisMonth = setSeconds(
    setMinutes(
      setHours(setDate(userDate, dayInThisMonth), startHour),
      startMinutes
    ),
    startSeconds
  );

  const endDateInThisMonth = new Date(
    startDateInThisMonth.getTime() + viewDuration
  );

  return endDateInThisMonth.getTime() - userDate.getTime();
};
